/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import Spinner from "components/spinner/spinner";
import { LoaderState } from "behaviors/loader/state";
import { StaticPageNotFoundError } from "./errors";
import { t } from "i18n";

interface LoaderProps {
  loader: LoaderState;
}

const Loader: React.SFC<LoaderProps> = ({ loader: { loading, error } }) => {
  if (loading) {
    return <Spinner message={t("common.loading")} />;
  }
  if (error && error instanceof StaticPageNotFoundError) {
    return (
      <React.Fragment>
        <p>{t("errors.error-occurred")}</p>
      </React.Fragment>
    );
  }

  return <p>{t("errors.unknown-error")}</p>;
};

export default Loader;
